module.exports = __webpack_public_path__ + "static/otherworldly-story-19fe909c039dda59d0fedc4f20e4e318.png";